var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"faq",attrs:{"id":"faq"}},[_c('Title',{attrs:{"title_id":"imgTitle-page-faq","title_text":_vm.$t('page-title.faq.title'),"subtitle_text":_vm.$t('page-title.faq.subtitle')}}),_c('Faq'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }